/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Form, Input, Collapse, Label } from 'reactstrap';
import { connect } from 'react-redux';
import {
  setPaymentType,
  clickPay,
  sendPaypalPayment,
  fullPageLoading,
} from '../actions/checkOutActions';
import Stripe from './Stripe';
import visa from '../images/visa.png';
import mastercard from '../images/mastercard.png';
import { PayPalButton } from 'react-paypal-button-v2';
import Spinner from './Spinner';

declare const process: any;

const Payment = (props: any) => {
  const { checkout, shoppingCart, guest, auth, discount } = props;

  const [paypalPaymentAuthorized, setPaypalPaymentAuthorized] = useState(false);
  const [paypalButtonLoading, setPaypalButtonLoading] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const updateWindowDimension = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', updateWindowDimension);
    return () => {
      window.removeEventListener('resize', updateWindowDimension);
    };
  }, []);

  const handleSetPaymentType = (e) => {
    props.setPaymentType(e.target.name);
  };

  const handlePayment = () => {
    props.clickPay();
  };

  const onApprove = (paymentData, actions) => {
    setPaypalPaymentAuthorized(true);
    props.fullPageLoading();
    actions.order.capture().then((details) => {
      if (checkout.paymentType === 'paypal') {
        let data: any = {};
        data.firstName = checkout.firstname;
        data.lastName = checkout.lastname;
        data.address = checkout.address;
        data.suburb = checkout.suburb;
        data.postcode = checkout.postcode;
        data.message = checkout.description;
        data.shippingFee = checkout.shippingFee;
        data.shippingType = checkout.shippingMethod;
        data.phoneNumber = checkout.phoneNumber;
        data.date = checkout.date;
        data.email = checkout.email;
        data.pickupTime = checkout.pickupTime;
        data.paymentId = details.purchase_units[0].payments.captures[0].id;
        data.cart = shoppingCart.cart;
        if (Object.keys(discount.userCoupon).length > 0) {
          data.coupon = discount.userCoupon;
        }

        if (auth.isAuthenticated) {
          data.userid = auth.user.id;
        } else if (guest.userid !== '') {
          data.userid = guest.userid;
        }
        props.sendPaypalPayment(data);
      }
    });
  };

  const onReady = () => {
    setPaypalButtonLoading(false);
  };

  let paymentOptions = {
    clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
    currency: 'AUD',
  };
  let buttonStyle = {
    color: 'blue',
    layout: 'horizontal',
    label: 'paypal',
    shape: 'pill',
    tagline: 'false',
  };

  let subTotal = 0;

  if (shoppingCart.cart.length !== 0) {
    subTotal =
      Math.round(
        shoppingCart.cart
          .map((eachItem) => eachItem.quantity * eachItem.product.price)
          .reduce((total, currentValue) => total + currentValue) * 100
      ) / 100;
  }

  let total = subTotal;
  let discountAmount;

  if (checkout.shippingFee !== null) {
    total = total + checkout.shippingFee;
  }

  if (Object.keys(discount.userCoupon).length > 0) {
    if (subTotal >= discount.userCoupon.minimumSpend) {
      if (discount.userCoupon.isPercent) {
        discountAmount = (subTotal / 100) * discount.userCoupon.amount;
      } else {
        discountAmount = discount.userCoupon.amount;
      }
    }
  }

  if (discountAmount !== undefined) {
    total = total - discountAmount;
  }
  if (total < 0) {
    total = 0;
  }

  return (
    <div>
      <div className=" mx-4">
        <Row className="">
          <Col className="">
            <table className="table border">
              <tbody>
                <tr>
                  <td>Contact</td>
                  <td> {checkout.email}</td>
                </tr>
                {checkout.shippingMethod === 'delivery' && (
                  <tr>
                    <td> Ship To</td>
                    <td>
                      <span>
                        {checkout.address}&nbsp;
                        {checkout.suburb}&nbsp;
                        {checkout.postcode}&nbsp;
                        {checkout.region}&nbsp;
                      </span>
                    </td>
                  </tr>
                )}
                <tr>
                  <td>Method</td>
                  <td>
                    <span>
                      {checkout.shippingMethod === 'pickup' && 'Pickup'}
                      {checkout.shippingMethod === 'freedelivery' && ' FREE Standard Shipping'}
                      {checkout.shippingMethod === 'delivery' && 'Standard Shipping'}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </div>
      <div className="mx-3 py-3">
        <h5 className="mx-2 pt-3 text-muted font-weight-bold">Payment</h5>
        <p className="mx-2">All transactions are secure and encrypted.</p>
        <div className="border ">
          <Row className={`mx-3 `}>
            <Col xs="12" className="border-bottom py-3">
              <Form className="d-inline pr-3">
                <Input
                  type="radio"
                  name="credit-card"
                  checked={checkout.paymentType === 'credit-card'}
                  onChange={handleSetPaymentType}
                />
              </Form>
              Credit Card
              <span className="float-right text-muted" style={{ cursor: 'default' }}>
                <img src={visa} alt="visa payment" style={{ height: 15 }} />
                <img src={mastercard} alt="visa payment" style={{ height: 20 }} />
                and more..
              </span>
            </Col>
            <Col xs="12">
              <Collapse isOpen={checkout.paymentType === 'credit-card'}>
                <Row className="py-3 border-bottom">
                  <Col>
                    <Stripe />
                  </Col>
                </Row>
              </Collapse>
            </Col>
          </Row>
        </div>
      </div>

      <div>
        <Row className="my-3">
          <Col>
            <Button
              disabled={checkout.buttonLoading}
              size="sm"
              color="dark"
              outline
              className="border-0 font-weight-bold"
              onClick={() => props.previousStep()}
            >
              &lt; User Details
            </Button>
          </Col>
          <Col className="text-right" style={{ marginRight: windowWidth < 500 && 70 }}>
            <div className="mx-3">
              {(checkout.paymentType === 'credit-card' || checkout.paymentType === null) && (
                <Button
                  size="sm"
                  disabled={
                    checkout.paymentType !== 'paypal' &&
                    (checkout.nameOnCard === '' ||
                      checkout.buttonLoading ||
                      checkout.cardNumber === null ||
                      !checkout.cardNumber.complete ||
                      checkout.cardExpiry === null ||
                      !checkout.cardExpiry.complete ||
                      checkout.cardCvc === null ||
                      !checkout.cardCvc.complete)
                  }
                  onClick={handlePayment}
                  color="success"
                  style={{ minWidth: 182 }}
                >
                  <span>Pay Now &gt;</span>
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  checkout: state.checkout,
  shoppingCart: state.cart,
  guest: state.guest,
  auth: state.form,
  discount: state.discount,
});

export default connect(mapStateToProps, {
  setPaymentType,
  clickPay,
  sendPaypalPayment,
  fullPageLoading,
})(Payment);
